/* eslint-disable no-restricted-imports */

import { Dispatch } from 'react';

import { AnyAction, configureStore } from '@reduxjs/toolkit';
import { routerMiddleware } from 'connected-react-router';
import { createBrowserHistory } from 'history';
import { throttle } from 'lodash';
import { useDispatch } from 'react-redux'; // This is the only place where this import is allowed.
import { persistStore } from 'redux-persist';
import { ELsKey, ls } from 'src/utils/localStorage';

import { createRootReducer } from './reducers';

export const history = createBrowserHistory();

export const store = configureStore({
  reducer: createRootReducer(history),
  middleware: (getDefaultMiddleware) => [
    routerMiddleware(history),
    // createLogger(),
    // On production env serializableCheck and immutableCheck are disabled
    ...getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST'],
      },
      immutableCheck: false,
    }),
  ],
  devTools: true,
});

store.subscribe(
  throttle(() => {
    const state = store.getState();

    ls.set(ELsKey.TOKEN_AUTH, state.auth.tokenAuth);
  }, 1000),
);

export const persistor = persistStore(store);

export type TAppDispatch = Dispatch<AnyAction>;

export const useAppDispatch = (): TAppDispatch => useDispatch<typeof store.dispatch>();

export type RootState = ReturnType<typeof store.getState>;
